import React, { useEffect, useRef } from "react";

const BoardLeagueRail = ({
  leagues = [],
  selectedId = "",
  onSelect,
  totalCount = 0,
}) => {
  const activeRef = useRef(null);

  useEffect(() => {
    activeRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "center",
    });
  }, [selectedId]);

  if (leagues.length === 0) return null;

  return (
    <div
      className="pmb-league-rail app-hscroll"
      role="tablist"
      aria-label="Filter by league"
    >
      <button
        type="button"
        role="tab"
        aria-selected={!selectedId}
        ref={!selectedId ? activeRef : null}
        className={`pmb-league-chip${!selectedId ? " pmb-league-chip-on" : ""}`}
        onClick={() => onSelect("")}
      >
        All
        <span className="pmb-league-chip-count">{totalCount}</span>
      </button>

      {leagues.map((league) => {
        const active = selectedId === league.id;
        return (
          <button
            key={league.id}
            type="button"
            role="tab"
            aria-selected={active}
            ref={active ? activeRef : null}
            className={`pmb-league-chip${active ? " pmb-league-chip-on" : ""}`}
            onClick={() => onSelect(active ? "" : league.id)}
            title={league.name}
          >
            {league.logo ? (
              <img src={league.logo} alt="" className="pmb-league-chip-logo" />
            ) : (
              <span className="pmb-league-chip-logo pmb-league-chip-logo-fallback">
                {(league.name || "L").slice(0, 1)}
              </span>
            )}
            <span className="pmb-league-chip-name">{league.name}</span>
            <span className="pmb-league-chip-count">{league.count}</span>
          </button>
        );
      })}
    </div>
  );
};

export default BoardLeagueRail;
